import { AlertComponent } from '../../../core/components/alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CreateAddressComponent } from '../create-address/create-address.component';
import { AddressService } from '../service/address/address.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { BehaviourService } from 'src/app/shared/services/behaviour.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Subscription, merge } from 'rxjs';
import { UploadComponent } from '../../mapping/upload/upload.component';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { of as observableOf } from 'rxjs';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-search-adress',
  templateUrl: './search-adress.component.html',
  styleUrls: ['./search-adress.component.scss'],
})
export class SearchAdressComponent implements OnInit, OnDestroy, AfterViewInit {
  selection = new SelectionModel<any>(true, []);
  dataSource = new MatTableDataSource();
  openedFrom: string = '';
  selectedRow: string = '';
  addressStatus: string;
  selectedAddress: any = [];
  deleteDisable = true;
  selectedTabForStatus: number = 0;
  displayedColumns: string[] = [
    'addressSelected',
    'NickName',
    'CompanyName',
    'ContactPersonName',
    'AddressLine1',
    'CityName',
    'PostalCode',
    'CountryCode',
    'addressValidated',
    'Action',
  ];
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageSizes = [5, 10, 15];
  totalData;
  searchKeywordFilter = new FormControl();
  role_type = [
    { type: 'Shipper', value: 'SHIPPER' },
    { type: 'Receiver', value: 'RECEIVER' },
  ];
  selected_roletype = this.role_type[0].value;

  addressList: any = [];
  defaultAddressList = [];
  defaultShipperAddresVal: string;
  defaultShipperAddressConfigId: string;
  subscription$ = new Subscription();
  actionPerformed;
  constructor(
    private addressService: AddressService,
    private configService: ConfigService,
    private behaviourService: BehaviourService,
    public dialog: MatDialog,
    private excelService: ExcelService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.filterBySearch();
    this.behaviourService.currentMessage.subscribe(message => {
      this.defaultShipperAddresVal = message;
    });
    this.getDefaultShipperAddress();
  }

  getHeaderForAddressDownload() {
    this.subscription$.add(
      this.addressService
        .getAddressSheet(
          sessionStorage.getItem('bbx-customerID'),
          sessionStorage.getItem('bbx-role')
        )
        .subscribe((response: string[]) => this.downloadTemplateExcel(response))
    );
  }

  getDefaultShipperAddress() {
    this.configService.fetchConfig('default_shipper_address').then(response => {
      if (response && response.data) {
        this.defaultShipperAddressConfigId = response.data[0]._id;
        this.defaultShipperAddresVal = response.data[0].address_id;
      }
    });
  }

  onStatusTabChange(event) {
    this.actionPerformed = event?.dataAction;
    if (this.actionPerformed != 'update') {
      this.paginator.pageIndex = 0;
    }
    this.selectedTabForStatus = event.index;
    this.selection.clear();
    this.selectedAddress = [];
    this.deleteDisable = true;
    event.index === 0
      ? (this.selected_roletype = 'SHIPPER')
      : (this.selected_roletype = 'RECEIVER');
    return event.index === 0 ? this.getAddressData('SHIPPER') : this.getAddressData('RECEIVER');
  }

  filterBySearch() {
    this.searchKeywordFilter.valueChanges
      .pipe(debounceTime(3000), distinctUntilChanged())
      .subscribe(() => {
        this.getAddressData(this.selected_roletype);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
  }

  getAddressData(role) {
    const requestData = {
      query: {
        address_type: [role],
      },
      limit: this.paginator.pageSize,
      page: this.actionPerformed ? this.paginator.pageIndex + 1 : 1,
      search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
      sort:
        this.sort.active === 'addressValidated'
          ? this.sort.active
          : this.sort.active && this.selected_roletype.toLowerCase().concat(this.sort.active),
      sortOrder: this.sort.direction === 'desc' ? -1 : 1,
    };
    this.addressService.getAddressList(requestData).subscribe(data => {
      this.assignDataSource(data);
    });
  }

  assignDataSource(data) {
    if (data.data.length > 0) {
      this.totalData = data.totalCount;
    } else {
      this.totalData = 0;
    }
    this.dataSource = new MatTableDataSource(data.data);
    this.addressList = this.formatAddressList(data.data);
    this.dataSource.data = this.defaultAddressList = this.addressList;
    this.actionPerformed = '';
  }

  formatAddressList(address_list_details) {
    address_list_details = address_list_details.filter(
      address => address.address_type == this.selected_roletype
    );
    const address_type = this.selected_roletype.toLowerCase();
    const address_list = [];
    address_list_details.map(address => {
      address_list.push({
        _id: address._id,
        address_id: address.address_id,
        addressStatus: address?.address_details?.Errors?.length ? 'Validation Failed' : 'Created',
        companyName: this.checkAddressData(address.address_details[`${address_type}CompanyName`]),
        contactPersonName: this.checkAddressData(
          address.address_details[`${address_type}ContactPersonName`]
        ),
        addressLine1: this.checkAddressData(address.address_details[`${address_type}AddressLine1`]),
        addressLine2: this.checkAddressData(address.address_details[`${address_type}AddressLine2`]),
        addressLine3: this.checkAddressData(address.address_details[`${address_type}AddressLine3`]),
        cityName: this.checkAddressData(address.address_details[`${address_type}CityName`]),
        postalCode: this.checkAddressData(address.address_details[`${address_type}PostalCode`]),
        countryCode: this.checkAddressData(address.address_details[`${address_type}CountryCode`]),
        countryName: this.checkAddressData(address.address_details[`${address_type}CountryName`]),
        email: this.checkAddressData(address.address_details[`${address_type}Email`]),
        phone: this.checkAddressData(address.address_details[`${address_type}Phone`]),
        mobilePhone: this.checkAddressData(address.address_details[`${address_type}MobilePhone`]),
        nickName: this.checkAddressData(address.address_details[`${address_type}NickName`]),
      });
    });
    return address_list;
  }

  checkAddressData(value) {
    return value ? value : '';
  }

  openDialogEdit(address_id, _id) {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        message: this.translate.instant('address.addressList.editAddressPopUp'),
        buttonText: {
          ok: 'Save',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data == 'true') {
        this.openEditAddress(address_id, _id);
      }
    });
  }

  openEditAddress(address_id, _id) {
    const dialogRef = this.dialog.open(CreateAddressComponent, {
      disableClose: true,
      autoFocus: false,
      maxHeight: '90vh',
      maxWidth: '90vw',
      data: {
        addressId: address_id,
        currentIndex: this.selectedTabForStatus,
        _id: _id,
        _configId: this.defaultShipperAddressConfigId,
        _defaultShipperAddresVal: this.defaultShipperAddresVal,
        openedFrom: 'Update',
      },
    });
    dialogRef.afterClosed().subscribe(close => {
      if (close._addressType === 'SHIPPER') {
        this.openEditAddress(close._addressID, close._id);
      }
      return close
        ? this.onStatusTabChange({ index: close?.data, address_id, dataAction: 'update' })
        : ``;
    });
  }

  openCreateAddress() {
    const dialogRef = this.dialog.open(CreateAddressComponent, {
      disableClose: true,
      autoFocus: false,
      maxHeight: '90vh',
      maxWidth: '90vw',
      data: {
        currentIndex: this.selectedTabForStatus,
        openedFrom: 'Create',
      },
    });
    dialogRef.afterClosed().subscribe(close => {
      if (close._addressType === 'SHIPPER') {
        this.openEditAddress(close._addressID, close._id);
      }
      return close ? this.onStatusTabChange({ index: close?.data }) : ``;
    });
  }

  openDialogDelete(id) {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        message: this.translate.instant('alert.deleteSure'),
        buttonText: {
          ok: this.translate.instant('global.save'),
          cancel: this.translate.instant('global.no'),
        },
      },
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data == 'true') {
        this.deleteAddress([id]);
      }
    });
  }

  deleteAddress(address_ids) {
    const reqBody = {
      body: { address_id: address_ids },
    };
    this.addressService.deleteAddress(reqBody).subscribe(() => {
      this.selection = new SelectionModel<any>(true, []);
      this.selectedAddress = [];
      this.deleteDisable = !this.deleteDisable;
      this.actionPerformed = 'delete';
      this.getAddressData(this.selected_roletype);
    });
  }

  getAddress(addressRow) {
    this.selectedRow = addressRow.address_id;
  }

  openUploadAddress() {
    const dialogRef = this.dialog.open(UploadComponent, {
      autoFocus: false,
      disableClose: true,
      width: '75vw',
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {
        isOpeningFrom: 'uploadAddress',
        file_uploadsource: 'address',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onStatusTabChange({ index: 0 });
      }
    });
  }

  downloadTemplateExcel(headers: string[]) {
    this.excelService.exportAsExcelFileWithHeader(headers, 'AddressBookTemplate');
  }

  getPageData() {
    return this.dataSource._pageData(this.dataSource._orderData(this.dataSource.data));
  }

  isEntirePageSelected() {
    return this.getPageData().every(row => this.selection.isSelected(row));
  }

  masterToggle() {
    this.deleteDisable = !this.deleteDisable;
    this.isEntirePageSelected()
      ? this.selection.deselect(...this.getPageData())
      : this.selection.select(...this.getPageData());

    this.updateSelection();
  }

  updateSelection() {
    this.selectedAddress = this.selection.selected.map(item => item.address_id);
    if (this.selectedAddress.length > 0) {
      this.deleteDisable = false;
    } else {
      this.deleteDisable = true;
    }
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
    this.behaviourService.sendEvent(null);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.sort.active = this.sort.active ? this.sort.active : '';
          const requestData = {
            query: {
              address_type: [this.selected_roletype],
            },
            limit: this.paginator.pageSize,
            page: this.paginator.pageIndex + 1,
            search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
            sort:
              this.sort.active === 'addressValidated'
                ? this.sort.active
                : this.sort.active && this.selected_roletype.toLowerCase().concat(this.sort.active),
            sortOrder: this.sort.direction === 'desc' ? -1 : 1,
          };
          return this.addressService
            .getAddressList(requestData)
            .pipe(catchError(() => observableOf(null)));
        }),
        map(empData => {
          if (empData == null) {
            this.totalData = 0;
            return [];
          }
          return empData;
        })
      )
      .subscribe(empData => {
        this.assignDataSource(empData);
      });
  }
}
